import { some } from 'lodash';
import { VeterinarianListingModel } from '../VeterinarianListingModel';

/**
 * This is a hospital schedule specific veterinarian model that extends the new VeterinarianListingModel, a lighter weight vet model
 * It is returned by the new hospital schedule end point.  Whether the vet has a DVM license for a hospital state or has access to the hospital
 * can be determined here.  But note, the activeDVMLicenseHospitalIds and accessibleHospitalIds are populated by getHospitalSchedule's response payload only for the requested hospitals on the request.
 * I.e. if you only request the schedule for hospital id 1205, you'll only have license and access info for hospital 1205, that's because vet's are only included if they're on the schedule for hospital 1205 or have access to hospital 1205.
 */
export class HospitalScheduleVeterinarianModel extends VeterinarianListingModel {
  activeDVMLicenseHospitalIds: number[];
  accessibleHospitalIds: number[];

  constructor(init?: Partial<HospitalScheduleVeterinarianModel>) {
    super(init);
    this.activeDVMLicenseHospitalIds =
      init?.activeDVMLicenseHospitalIds?.map((id) => id) ?? ([] as number[]);
    this.accessibleHospitalIds =
      init?.accessibleHospitalIds?.map((id) => id) ?? ([] as number[]);
  }

  isLicensed(hospitalId: number) {
    return some(
      this.activeDVMLicenseHospitalIds.filter((l) => l === hospitalId),
    );
  }

  hasAccess(hospitalId: number) {
    return some(this.accessibleHospitalIds.filter((l) => l === hospitalId));
  }

  isActive = () => this.employmentStatus === 'A';
}
